export default __webpack_public_path__ + "static/media/epic_cat.ca90b05d.jpg";